export default __webpack_public_path__ + "static/media/layer.c9fbc316.png";